module.exports = __webpack_public_path__ + "img/brown-wooden-coffee-table-below-an-uplight-chandelier-68389.220f45bc.jpg";